@if ($mode() == Enums.FlowInboxDirectoryMode.Creating) {
    <div class="card shadow body-container folder-edit">
        <div class="card-body">
            <input type="text" placeholder="Nome da pasta" onfocus="this.select()" autofocus
                   [ngModel]="$flowInboxDirectoryName()"
                   (ngModelChange)="$flowInboxDirectoryName.set($event)"
                   (keyup.enter)="confirm()"
            />
            <hr>
            <div class="actions">
                <button type="button" class="btn btn-outline-danger" (click)="cancel()">
                    <i class="fas fa-times mr-1"></i>
                    Cancelar
                </button>
                <button type="button" class="btn btn-outline-primary" (click)="confirm()">
                    <i class="fas fa-check mr-1"></i>
                    Confirmar
                </button>
            </div>
        </div>
    </div>
} @else if ($mode() == Enums.FlowInboxDirectoryMode.Viewing) {
    <div class="card shadow body-container">
        <div class="card-body">
            <h6 class="title m-0" #titleWrapperRef
                [matTooltip]="$flowInboxDirectory()?.name"
                [matTooltipDisabled]="!isOverflown(titleWrapperRef)"
                (click)="open()"
                (keyDown)="open()"
            >
                <span #titleRef>{{ $flowInboxDirectory()?.name }}</span>
            </h6>

            <hr>

            <div class="body">
                <!-- Tags -->
                <div class="tags">
                    <span class="flow-count">
                        {{ $flowInboxDirectory().flowDefinitions.length }} {{ $flowInboxDirectory().flowDefinitions.length === 1 ? 'Fluxo' : 'Fluxos' }}
                    </span>
                </div>

                <!-- Ações -->
                <div class="actions">
                    <!-- Visualizar Fluxos -->
                    <a class="card-link" matTooltip="Visualizar"
                       (click)="open()"
                       (keyDown)="open()"
                    >
                        <i class="fas fa-right-to-bracket"></i>
                    </a>

                    <!-- Adicionar Fluxos -->
                    <a class="card-link" matTooltip="Adicionar Fluxos"
                       (click)="executeAction(Enums.FlowDefinitionItemActionType.AddItemToDirectoryMode)"
                       (keyDown)="executeAction(Enums.FlowDefinitionItemActionType.AddItemToDirectoryMode)"
                    >
                        <i class="fas fa-folder-plus"></i>
                    </a>

                    <!-- Editar Pasta -->
                    <a class="card-link" matTooltip="Editar Pasta"
                       (click)="edit()"
                       (keyDown)="edit()"
                    >
                        <i class="fas fa-pen"></i>
                    </a>

                    <!-- Excluir Pasta -->
                    <a class="card-link" matTooltip="Excluir Pasta"
                       (click)="delete()"
                       (keyDown)="delete()"
                    >
                        <i class="fas fa-trash"></i>
                    </a>
                </div>

                <!-- Mensagem drag-and-drop -->
                <div class="drag-drop-message">
                    <i class="fas fa-up-down-left-right mr-2"></i>
                    <span>Solte aqui e mova para esta pasta</span>
                </div>
            </div>
        </div>
    </div>
}
